import utcToZonedTime from 'date-fns-tz/utcToZonedTime';
import addDays from 'date-fns/addDays';
import differenceInDays from 'date-fns/differenceInDays';
import { type IntlShape } from 'react-intl-next';

import { NavigationMode, NavigationPeriodId } from '@atlassian/eoc-schedule-common';

import { messages } from './messages';

const formatScheduleDate = ({
	intlApi,
	startEpoch,
	endEpoch,
	range,
	view,
	startOffset,
	endOffset,
	variant,
}: {
	intlApi: IntlShape;
	startEpoch: number;
	endEpoch: number;
	startOffset: number;
	endOffset: number;
	range: NavigationPeriodId;
	view: NavigationMode;
	variant: 'short' | 'long';
}) => {
	const startDate = utcToZonedTime(startEpoch + startOffset, 'UTC');
	const endDate = utcToZonedTime(endEpoch + endOffset - 1, 'UTC');

	if (view === NavigationMode.Timeline) {
		return range === NavigationPeriodId.OneDay
			? intlApi.formatMessage(messages.dateSingle, {
					weekDayLong: intlApi.formatDate(startDate, {
						weekday: 'long',
					}),
					monthShort: intlApi.formatDate(startDate, {
						month: variant,
					}),
					dayNumeric: intlApi.formatDate(startDate, {
						day: 'numeric',
					}),
				})
			: intlApi.formatMessage(messages.dateRange, {
					startMonthShort: intlApi.formatDate(startDate, {
						month: variant,
					}),
					startDayNumeric: intlApi.formatDate(startDate, {
						day: 'numeric',
					}),
					endMonthShort: intlApi.formatDate(endDate, {
						month: variant,
					}),
					endDayNumeric: intlApi.formatDate(endDate, {
						day: 'numeric',
					}),
				});
	}

	const midDate = addDays(startDate, Math.floor(differenceInDays(endDate, startDate) / 2));

	if (view === NavigationMode.Calendar) {
		return intlApi.formatMessage(messages.dateCalendar, {
			monthLong: intlApi.formatDate(midDate, {
				month: 'long',
			}),
			yearLong: intlApi.formatDate(midDate, {
				year: 'numeric',
			}),
		});
	}
};

// TODO: make common
const timelineTypeToName = (timelineType: NavigationPeriodId): string => {
	switch (timelineType) {
		case NavigationPeriodId.OneDay:
			return 'oneDay';
		case NavigationPeriodId.OneWeek:
			return 'oneWeek';
		case NavigationPeriodId.TwoWeeks:
			return 'twoWeeks';
		case NavigationPeriodId.OneMonth:
			return 'oneMonth';
	}
};

export { formatScheduleDate, timelineTypeToName };
